import { MODAL_HEIGHT } from "@/constants";
import { ConfirmationDialog } from "@biom3/react";
import { CustomRive } from "../CustomRive";

type ClaimModalProps = {
  title: string;
  caption?: string;
  onClaim: () => void;
  onViewQuest: () => void;
  onClose: () => void;
};

export const ClaimModal = ({
  title,
  caption,
  onClaim,
  onViewQuest,
  onClose,
}: ClaimModalProps) => {
  return (
    <ConfirmationDialog visible>
      <ConfirmationDialog.Content sx={{ height: MODAL_HEIGHT }}>
        <ConfirmationDialog.Content.Title>
          {title}
        </ConfirmationDialog.Content.Title>
        <ConfirmationDialog.Content.Caption>
          {caption ??
            "Click claim to receive your reward if you have completed the quest."}
        </ConfirmationDialog.Content.Caption>
        <ConfirmationDialog.Content.RiveBox
          rc={<CustomRive src="/rive/spinning_gem.riv" />}
          testId="riveBox"
        />
        <ConfirmationDialog.Content.Button onClick={onViewQuest}>
          View Quest
        </ConfirmationDialog.Content.Button>
        <ConfirmationDialog.Content.Button onClick={onClaim}>
          Claim
        </ConfirmationDialog.Content.Button>
        <ConfirmationDialog.Content.CloseButtCon onClick={onClose} />
      </ConfirmationDialog.Content>
    </ConfirmationDialog>
  );
};
